import React, { useState } from "react";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../CustomComponent/custom_input";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import { FcAdvertising } from "react-icons/fc";
import Footer from "../../../Components/Footer/footer";
import { BsBoxArrowInRight } from "react-icons/bs";
import { salaryPayroleSchema } from "../../../Schemas/user/payrole_password";
import axios from "axios";
import { setCred } from "../../../redux/Payrole/payroleReducer";
const SalaryLogin = () => {
  const store = useSelector((store) => store.login);
  const payroleCred = useSelector((store) => store.payroleReducer?.cred);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const showPassword = () => {
    setShowPass(!showPass);
  };

  const handelSubmit = async (values, actions) => {
    try {
      setLoading(true);

      const payload = {
        userId: store?.user?.UserId,
        password: values?.password,
        email: store?.user?.Email,
      };

      const res = await axios.post(
        `https://payroll-817182422433.asia-south1.run.app/employeeManagement/loginPayroll`,
        payload,
        { headers: payroleCred }
      );

      if (res.status === 200) {
        dispatch(setCred(payload));
        Toast("success", "Login Successfully");
        navigate("/employee-salary");
      }
    } catch (err) {
      Toast("error", err?.response?.data?.msg || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // const handelSubmitPassword = (values) => {
  //   console.log(values);

  //   Toast("success", "Password Created Successfully");
  //   setShowSignupModal(false);
  // };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page page-center mt-7">
      <div className="container container-tight py-4">
        {/* <div className="text-center mt-4 mb-4">
          <span>
            <h1 className="fs-large m-0 p-0">
              <span className="text-primary">α</span>lpha
            </h1>
            <p className="fs-5 ps-6 m-0 text-success">by KRYZEN</p>
          </span>
        </div> */}
        <div className="card card-md ">
          <div className="card-body">
            <h1 className="text-center mb-1">
              {" "}
              Welcome To Kryzen Payroll Portal
            </h1>

            <p className="mb-3 text-center">
              Access your salary details, payslips, attendance records, and
              employee information securely.
            </p>
            {/* <hr className="p-1 m-1"></hr> */}
            <div class="hr-text">Login</div>
            <Formik
              initialValues={{ password: "" }}
              validationSchema={salaryPayroleSchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form id="k-user-login-form">
                  <div className="mb-3">
                    <label className="form-label">User Name</label>
                    <CustomInput
                      type="text"
                      name="name"
                      value={store?.user?.Name || ""}
                      disabled
                    />

                    {/* {props.touched.email && props.errors.email && (
                      <p className="text-danger">{props.errors.email}</p>
                    )} */}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <CustomInput
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      autoComplete="off"
                      value={store?.user?.Email || ""}
                      disabled
                    />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Password</label>
                    <div className="input-group input-group-flat">
                      <CustomInput
                        name="password"
                        autoComplete="off"
                        placeholder="Enter password"
                        type={showPass ? "text" : "password"}
                      />

                      <span className="input-group-text">
                        <span
                          onClick={showPassword}
                          className="link-secondary"
                          title="Show password"
                          role="button"
                          data-bs-toggle="tooltip"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                            <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                          </svg>
                        </span>
                      </span>
                    </div>
                    {props.touched.password && props.errors.password && (
                      <p className="text-danger">{props.errors.password}</p>
                    )}
                  </div>
                  {/* <div className="mb-2">
                    <label className="form-check">
                      <input type="checkbox" className="form-check-input" />
                      <span className="form-check-label">Remember me</span>
                    </label>
                  </div> */}
                  <div className="form-footer">
                    {/* <FormSubmitButton buttonText={"Log in"} width={"full"} /> */}
                    <button
                      type="submit"
                      className="btn btn-green text-white w-100 mt-2"
                    >
                      <BsBoxArrowInRight className="fs-2 me-2" />
                      Log in
                    </button>
                  </div>
                  {/* <div className="my-3 mx-2">
                    <span>
                      <a href="/forgot-password">Forgot your password?</a>
                    </span>
                  </div> */}
                  {/* <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none"
                      onClick={() => setShowSignupModal(true)}
                    >
                      Create New Password
                    </button>
                  </div> */}
                </Form>
              )}
            </Formik>
          </div>
          <div class="hr-text">or</div>
          <div className="card-body">
            <p className="p-0 m-0">
              {" "}
              <FcAdvertising /> Need assistance with your employee account?
            </p>
            <h3 className="p-0 m-0">Contact 9870-424-425 / HR@KRYZEN.COM</h3>
          </div>
        </div>
        <p className="p-0 my-1 text-center">
          &copy; 2019-2026 Kryzen Biotech Private Limited.
        </p>
      </div>
      <Footer></Footer>
      {/* <div
        className={`modal modal-blur fade show border ${
          showSignupModal ? "show d-block" : ""
        }`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create New Password</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowSignupModal(false)}
              ></button>
            </div>

            <Formik
              initialValues={{
                password: "",
                confirmPassword: "",
              }}
              validationSchema={CreatePasswordSchema}
              onSubmit={(values) => {
                console.log(values);

                if (values.password !== values.confirmPassword) {
                  Toast("error", "Passwords do not match");
                  return;
                }

                // API Call Here

                Toast("success", "Password Created Successfully");
                setShowSignupModal(false);
              }}
            >
              {(props) => (
                <Form>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Create Password</label>
                      <CustomInput
                        type="password"
                        name="password"
                        placeholder="Enter New Password"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <CustomInput
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                      />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowSignupModal(false)}
                    >
                      Cancel
                    </button>

                    <button type="submit" className="btn btn-primary">
                      Create Password
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div> */}
      {/* {showSignupModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowSignupModal(false)}
          ></div>

          <div
            className="modal modal-blur fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Create New Password</h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSignupModal(false)}
                  />
                </div>

                <Formik
                  initialValues={{
                    password: "",
                    confirmPassword: "",
                  }}
                  validationSchema={CreatePasswordSchema}
                  onSubmit={handelSubmitPassword}
                >
                  {(props) => (
                    <Form>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Create Password</label>

                          <CustomInput
                            type="password"
                            name="password"
                            placeholder="Enter New Password"
                          />

                          {props.touched.password && props.errors.password && (
                            <div className="text-danger mt-1">
                              {props.errors.password}
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Confirm Password</label>

                          <CustomInput
                            type="password"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                          />

                          {props.touched.confirmPassword &&
                            props.errors.confirmPassword && (
                              <div className="text-danger mt-1">
                                {props.errors.confirmPassword}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowSignupModal(false)}
                        >
                          Cancel
                        </button>

                        <button type="submit" className="btn btn-primary">
                          Create Password
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
};

export default SalaryLogin;
